// extracted by mini-css-extract-plugin
export default {"content":"ApartmentCardApartmentInformation_content__qZhoG","bar":"ApartmentCardApartmentInformation_bar__VBOyj"};